import { ApiError } from "../api";
import { eventFeedback } from "./event-feedback";
export function bidFeedback(error: unknown) {
  if (error instanceof ApiError) {
    const code = [
      "bid_window_changed",
      "bid_adoption_required",
      "bid_review_changed",
      "bid_review_invalid",
      "bid_open_only",
      "bid_resume_required",
      "bid_document_not_ready",
      "bid_document_changed",
      "bid_operation_grant_unavailable",
    ].find((code) => code === error.code);
    if (code)
      return code as
        | "bid_window_changed"
        | "bid_adoption_required"
        | "bid_review_changed"
        | "bid_review_invalid"
        | "bid_open_only"
        | "bid_resume_required"
        | "bid_document_not_ready"
        | "bid_document_changed"
        | "bid_operation_grant_unavailable";
  }
  return eventFeedback(error);
}
export type BidFeedback =
  | ReturnType<typeof bidFeedback>
  | "blocked"
  | "storage"
  | "success"
  | "transferUnknown";
